import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function getPartners() {
  const { data } = await api.get("/partners");
  return data;
}

export async function getCalculatorConfig() {
  const { data } = await api.get("/calculator-config");
  return data;
}

export async function submitLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}

export function trackPageview(path) {
  // cookie-free, fire-and-forget
  try {
    api.post("/analytics/pageview", { path });
  } catch (e) {
    /* no-op */
  }
}
